/**
 * Marks a self-fetching widget as driven by the dashboard tag/plan filters.
 * Pairs with dashboardWidget.mixin.
 *
 * No watcher: DashboardGrid batches a filter commit and bumps reloadToken, so
 * refetching here too would fan it back out into a request per widget.
 */
export default {
  props: {
    tagIds: { type: Array, default: () => [] },
    planTypes: { type: Array, default: () => [] }
  }
};
